export function compressImageToBase64(
  file: File,
  maxWidth: number,
  quality: number = 0.7,
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = () => {
      img.src = reader.result as string;
    };
    reader.onerror = () => reject(new Error('读取文件失败'));
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Canvas 初始化失败'));
        return;
      }
      let w = img.naturalWidth;
      let h = img.naturalHeight;
      if (w > maxWidth) {
        h = Math.round(h * (maxWidth / w));
        w = maxWidth;
      }
      canvas.width = w;
      canvas.height = h;
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, w, h);
      ctx.drawImage(img, 0, 0, w, h);
      const dataUrl = canvas.toDataURL('image/jpeg', quality);
      resolve(dataUrl);
    };
    img.onerror = () => reject(new Error('图片加载失败'));
    reader.readAsDataURL(file);
  });
}

// =============================================================
// 缩略图地址推导
// =============================================================
// 后台上传时后端会自动生成缩略图：<url 所在目录>/thumbs/<同名>.jpg
// 例如 https://域名/uploads/cases/1700-abc.jpg
//   -> https://域名/uploads/cases/thumbs/1700-abc.jpg
// 远程图 / data URL / 未生成缩略图的老图，在图片加载失败时会自动回退到原图。
const IMAGE_EXT_RE = /\.(jpe?g|png|webp|gif|bmp|tiff?|avif|svg)$/i;

export function getThumbUrl(url: string | null | undefined): string {
  if (!url) return '';
  const value = String(url).trim();
  if (!value) return '';

  // 只管站内上传目录，其余（远程图、data URL、/images/ 静态图）原样返回
  if (!value.includes('/uploads/')) return value;
  // 已经是缩略图地址，直接用
  if (/\/uploads\/[^/]+\/thumbs\//.test(value)) return value;

  const splitIndex = value.search(/[?#]/);
  const base = splitIndex === -1 ? value : value.slice(0, splitIndex);
  const suffix = splitIndex === -1 ? '' : value.slice(splitIndex);

  const slash = base.lastIndexOf('/');
  if (slash === -1) return value;
  const dir = base.slice(0, slash);
  const name = base.slice(slash + 1);
  if (!name) return value;

  let stem = name;
  let prev = '';
  do {
    prev = stem;
    stem = stem.replace(IMAGE_EXT_RE, '');
  } while (stem !== prev);

  if (!stem) return value;
  return `${dir}/thumbs/${stem}.jpg${suffix}`;
}